import { memo } from 'react';
import { useDareFormContext } from 'root/src/client/v2/_pages/add-campaign/contexts/dareForm.context';
import { useController } from 'react-hook-form';
import { FormControl } from '@mui/material';
import TextField from '@mui/material/TextField';
import { ErrorField } from 'root/src/client/v2/_pages/add-campaign/components/AddCampaignForm/ErrorField';
import { RequiredMark } from 'root/src/client/v2/_pages/add-campaign/components/AddCampaignForm/RequiredMark';
export const TitleField = memo(() => {
    var _a;
    const form = useDareFormContext();
    const { field, fieldState, } = useController({
        name: 'title',
        control: form.control,
    });
    return (<FormControl data-error={Boolean(fieldState.error)} error={Boolean(fieldState.error)}>
			<label className="capitalize font-bold" htmlFor="title">
				<RequiredMark />
				Title
			</label>
			<TextField {...field} id="title" variant="filled" size="small" placeholder="Give your dare a catchy title" fullWidth error={Boolean(fieldState.error)}/>
			<ErrorField error={(_a = fieldState.error) === null || _a === void 0 ? void 0 : _a.message}/>
		</FormControl>);
});
